export const peers = [/*"https://gun-eu.herokuapp.com/gun", */"https://smixqse-gun.glitch.me/gun", "https://smixqse-gun.herokuapp.com/gun"]
export const SEA = Gun.SEA;
export const gun = Gun(peers, {localStorage: false});